import { encryptRequest, decryptResponse, produceAESKey } from "./cryptoHelper";
import { apiGet } from "./apiClient";

const baseHeaders = { 'Content-Type': 'application/json' };

export const getReportsFromAPI = async (token, survey_id) => {
    const { aesKeyBase64, encryptedAESKey } = produceAESKey();

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        queryStringParameters: { encryptedKey: encryptedAESKey },
    };

    const response = await apiGet(`/reports/${survey_id}`, requestInfo);
    return decryptResponse(response, aesKeyBase64);
};
